var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabsLayout',[_c('ElTabPane',{attrs:{"name":"financeRechargeLog","label":"充值记录"}}),_c('ElTabPane',{attrs:{"name":"financeTransferLog","label":"转账记录"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }